import { isDefined } from "@grandvisionhq/utils";
const specificationDictionary = {
  accessoryColor: "accessoryColor",
  accessoryColorUnlocalized: "accessoryColorUnlocalized",
  accessoryTypeUnlocalized: "accessoryTypeUnlocalized",
  accessoryType: "accessoryType",
  articleNumber: "articleNumber",
  brand: "brand",
  erpId: "erpId",
  faceShape: "faceShape",
  frameColor: "frameColor",
  frameColorUnlocalized: "frameColorUnlocalized",
  frameMaterial: "frameMaterial",
  frameMaterialUnlocalized: "frameMaterialUnlocalized",
  frameShape: "frameShape",
  frameShapeUnlocalized: "frameShapeUnlocalized",
  frameType: "frameType",
  frameTypeUnlocalized: "frameTypeUnlocalized",
  frameSize: "frameSize",
  isGlazeble: "glazeble",
  isMirror: "mirror",
  isGradient: "gradient",
  lensColor: "lensColor",
  opcoBackendId: "opcoBackendId",
  // used for the Article Number on some opcos.
  isPolarized: "polarized",
  prescriptionGlass: "prescriptionGlass",
  roadworthiness: "roadworthiness",
  supplierEAN: "supplierEAN",
  targetGender: "gender",
  genderUnlocalized: "genderUnlocalized",
  templeType: "templeType",
  templeColor: "templeColor",
  trend: "trend",
  segment: "segment",
  material: "material",
  // used for the Contact Lens and Accessories material
  materialUnlocalized: "materialUnlocalized",
  // used for Accessories material
  sku: "sku",
  brandModel: "brandModel",
  brandModelCode: "brandModelCode",
  // used for the Frame and Sunglasses brandModelCode
  brandModelColorCode: "brandModelColorCode",
  // Contact Lens specifications
  hasUvProtection: "features.uv",
  lensType: "lensType",
  // used for the Contact Lens lensType.
  lensTypeUnlocalized: "lensTypeUnlocalized",
  materialType: "materialType",
  packageQuantity: "packageQuantity",
  waterContent: "waterContent",
  replacementFrequency: "replacementFrequency",
  replacementFrequencyUnlocalized: "replacementFrequencyUnlocalized",
  // Solutions specifications
  lensTypeTarget: "lensTypeTarget",
  caseIncluded: "caseIncluded",
  minimumCycleTime: "minimumCycleTime",
  preservativeFree: "preservativeFree",
  maxTimeFrameInLensCase: "maxTimeFrameInLensCase",
  expirationAfterOpening: "expirationAfterOpening",
  packageOption: "packageOption"
};
const getSpecificationItems = (serverSpecifications) => {
  const clientSpecifications = Object.entries(serverSpecifications).map(([graphKey, value]) => {
    const specificationAttribute = specificationDictionary[graphKey];
    if (!specificationAttribute || value === null || value === void 0 || value === "" || Array.isArray(value) && value.length === 0) {
      return void 0;
    }
    return {
      specificationAttribute,
      value
    };
  });
  return clientSpecifications.filter(isDefined);
};
export {
  getSpecificationItems
};
//# sourceMappingURL=get-specification-items.js.map
